export enum PC_ASSET_PATH {
  HANDOUT_IMAGES = '/assets/documents/pc-handout-bilder.pdf',
  HANDOUT_CREWCARD = '/assets/documents/pc-handout-crewcard.pdf',
  HANDOUTS_COCKPIT_GASTRO = '/assets/documents/useful-information-handouts/pc-handout-cockpit-gastro.pdf',
  HANDOUTS_COCKPIT_SHOPS = '/assets/documents/useful-information-handouts/pc-handout-cockpit-shops.pdf',
  HANDOUTS_COCKPIT_ENTERTAINMENT = '/assets/documents/useful-information-handouts/pc-handout-cockpit-entertainment.pdf',
  HANDOUTS_COCKPIT_MANAGER = '/assets/documents/useful-information-handouts/pc-handout-cockpit-manager.zip',
}
